enum ScenarioType {
  AccordingToPlan,
  HighInflation,
  LiveThreeYearsLonger,
  PotsFallTwentyPercent,
  NeedExtraMoneyForLastTwoYears,
  LowerGrowth
}

export default ScenarioType;
